import { AwsRum } from 'aws-rum-web';
import RumSettings from './RumSettings';

class Rum {
  awsRum: AwsRum;

  constructor(rumSettings: RumSettings) {
    rumSettings.configuration.telemetries = createTelemetries();
    this.awsRum = new AwsRum(
      rumSettings.applicationId,
      rumSettings.version,
      rumSettings.region,
      rumSettings.configuration,
    );
  }
}

function createTelemetries() {
  return [
    'http',
    'errors',
    ['performance', {
      ignore: (entry: PerformanceEntry) => {
        if (entry.entryType.toLocaleLowerCase() !== 'navigation') {
          return true;
        }
        if ((entry as PerformanceNavigationTiming).type?.toLocaleLowerCase() !== 'back_forward') {
          return true;
        }

        return false;
      },
    }],
    ['interaction',
      {
        enableMutationObserver: true,
        events:
        [{
          cssLocator: '#tn-payment-submit-button',
          event: 'click',
        },
        ],
      }]];
}

export default Rum;
